import { FETCH_ASSIGNED_DEVICES, CLEAR_ASSIGNED_DEVICES } from '#action/types';

const defaultState = [];

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_ASSIGNED_DEVICES:
      return action.payload.filter(d => d.appliances || d.shipments);
    case CLEAR_ASSIGNED_DEVICES:
      return defaultState;
    default:
      return state;
  }
}
